export default "__VITE_ASSET__B9xOyk0Q__"